// extracted by mini-css-extract-plugin
module.exports = {"btn":"Button_btn__2jK9g","primary":"Button_primary__f5uu3","danger":"Button_danger__ClkBS","ghost":"Button_ghost__2TMAY"};